import { isAllowedProtocol, parseChangeUrl } from './parseChangeUrl';

/**
 * Change-owned sites that don't serve user uploads. A new host is added here, in code, after
 * checking that it serves no user-controlled content. Never use a `*.change.org` wildcard: it
 * includes the upload hosts (`assets.`, `static.`, `videohost.`, ...).
 */
const CONTENT_HOSTS = new Set([
	'help.change.org',
	'guide.change.org',
	'careers.change.org',
	'www.changefoundation.org',
]);

/**
 * Whether `url` is on a first-party content host. These are trusted links, never a valid automatic
 * redirect target.
 *
 * `baseUrl` must be a Change app host or this returns `false`. Never throws.
 */
export function isChangeContentUrl(url: string, { baseUrl }: { baseUrl: string }): boolean {
	const parsed = parseChangeUrl(url, baseUrl);
	return (
		!!parsed && isAllowedProtocol(parsed.parsedUrl, parsed.parsedBaseUrl) && CONTENT_HOSTS.has(parsed.parsedUrl.host)
	);
}
